import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './ucount.component.scss';
var Ucount = /** @class */ (function (_super) {
    tslib_1.__extends(Ucount, _super);
    function Ucount(element) {
        return _super.call(this, element) || this;
    }
    Ucount.prototype.init = function () { };
    Ucount.prototype.bindEvents = function () { };
    return Ucount;
}(Base));
export { Ucount };



//////////////////
// WEBPACK FOOTER
// ./components/ucount/ucount.component.ts
// module id = 545
// module chunks = 0